
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class WPDivider extends Vue {
  @Prop({ default: false })
  private readonly primary?: boolean
}
